(() => {
  const MOBILE_BREAKPOINT = 989;

  const pushFitMonthProductSelectItem = (section, button) => {
    window.dataLayer = window.dataLayer || [];

    const listId = section.dataset.ga4ItemListId || "";
    const listName = section.dataset.ga4ItemListName || "";
    const currency = section.dataset.ga4Currency || "USD";
    const d = button.dataset;

    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: "ga4Event",
      event_name: "select_item",
      event_parameters: {
        item_list_id: listId,
        item_list_name: listName,
        currency,
        button_name: d.ga4ButtonName || "",
        items: [
          {
            item_id: d.ga4ItemId || "",
            item_name: d.ga4ItemName || "",
            discount: d.ga4Discount != null && d.ga4Discount !== "" ? String(d.ga4Discount) : "0",
            index: d.ga4Index != null && d.ga4Index !== "" ? String(d.ga4Index) : "",
            item_list_id: listId,
            item_list_name: `Navigation _ ${listName}`,
            itemCategory: d.ga4ItemCategory || "",
            itemCategory2: d.ga4ItemCategory2 || "",
            itemCategory3: d.ga4ItemCategory3 || "",
            itemCategory4: d.ga4ItemCategory4 || "",
            itemCategory5: d.ga4ItemCategory5 || "",
            item_variant: d.ga4ItemVariant || "",
            item_brand: "SHOKZ",
            price: d.ga4Price != null && d.ga4Price !== "" ? String(d.ga4Price) : "0",
            quantity: d.ga4Quantity != null && d.ga4Quantity !== "" ? String(d.ga4Quantity) : "1",
            currency
          }
        ]
      }
    });
  };

  const initSection = (section) => {
    const swiperEl = section.querySelector("[data-fit-month-product-swiper]");
    if (!swiperEl || typeof Swiper === "undefined") {
      return;
    }

    const paginationEl = section.querySelector("[data-fit-month-product-pagination]");
    const prevEl = section.querySelector("[data-fit-month-product-prev]");
    const nextEl = section.querySelector("[data-fit-month-product-next]");
    const mediaQuery = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);
    let swiperInstance = null;

    const mountSwiper = () => {
      if (swiperInstance || !mediaQuery.matches) {
        return;
      }

      swiperInstance = new Swiper(swiperEl, {
        slidesPerView: 1,
        speed: 500,
        pagination: {
          el: paginationEl,
          clickable: true
        },
        navigation: {
          prevEl,
          nextEl
        }
      });
    };

    const unmountSwiper = () => {
      if (!swiperInstance) {
        return;
      }
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    };

    const syncSwiper = () => {
      if (mediaQuery.matches) {
        mountSwiper();
      } else {
        unmountSwiper();
      }
    };

    syncSwiper();

    if (typeof mediaQuery.addEventListener === "function") {
      mediaQuery.addEventListener("change", syncSwiper);
    } else if (typeof mediaQuery.addListener === "function") {
      mediaQuery.addListener(syncSwiper);
    }

    section.addEventListener("click", (event) => {
      const target = event.target;
      if (!(target instanceof Element)) {
        return;
      }
      const button = target.closest("a[data-ga4-product-cta]");
      if (!button || !section.contains(button)) {
        return;
      }
      pushFitMonthProductSelectItem(section, button);
    });
  };

  const initAll = () => {
    document.querySelectorAll('[id^="fit-month-product-"]').forEach((section) => {
      initSection(section);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
